import { extractApiError, type HttpApiClient } from "@vana/core";
import { FileProblemReportError, UploadEvidenceError } from "../../domain/errors/errors";
import {
  type FileProblemReportParams,
  type ProblemReportRepository,
  type UploadEvidenceParams,
} from "../../domain/repos/problem-report-repo";

// Capture type for the optional evidence photo (matches the backend CHECK).
const EVIDENCE_CAPTURE_TYPE = "problem_report_evidence";

export class ProblemReportRepo implements ProblemReportRepository {
  constructor(private readonly apiClient: HttpApiClient) {}

  // The reporting ambassador is the session user (the BFF forwards it).
  async fileReport({
    requestId,
    reason,
    description,
    lat,
    long,
  }: FileProblemReportParams): Promise<void> {
    try {
      await this.apiClient.post(`v1/requests/${requestId}/problem-reports`, {
        reason,
        description,
        lat,
        long,
      });
    } catch (error) {
      const { message, apiError } = extractApiError(error);
      throw new FileProblemReportError(message, apiError);
    }
  }

  async uploadEvidence({ requestId, image }: UploadEvidenceParams): Promise<void> {
    try {
      const form = new FormData();
      form.append("type", EVIDENCE_CAPTURE_TYPE);
      form.append("file", image, `${EVIDENCE_CAPTURE_TYPE}.jpg`);
      await this.apiClient.post(`v1/requests/${requestId}/captures`, form);
    } catch (error) {
      const { message, apiError } = extractApiError(error);
      throw new UploadEvidenceError(message, apiError);
    }
  }
}
